var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnpublished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94001 5.12L6.49001 3.66C8.07001 2.61 9.96001 2 12 2C17.52 2 22 6.48 22 12C22 14.04 21.39 15.93 20.34 17.51L18.88 16.05C19.59 14.86 20 13.48 20 12C20 7.59 16.41 4 12 4C10.52 4 9.14001 4.41 7.94001 5.12ZM17.66 9.53L16.25 8.12L13.6 10.77L15.01 12.18L17.66 9.53ZM19.78 22.61L17.51 20.34C15.93 21.39 14.04 22 12 22C6.48001 22 2.00001 17.52 2.00001 12C2.00001 9.96 2.61001 8.07 3.66001 6.49L1.39001 4.22L2.80001 2.81L21.18 21.19L19.78 22.61ZM16.06 18.88L12.18 15L10.59 16.59L6.35001 12.35L7.76002 10.94L10.59 13.77L10.77 13.59L5.12001 7.94C4.41001 9.14 4.00001 10.52 4.00001 12C4.00001 16.41 7.59001 20 12 20C13.48 20 14.86 19.59 16.06 18.88Z",
    fill: "#003A5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpublished);
export default __webpack_public_path__ + "static/media/unpublished.0ac055b14918480d9070e8032964daec.svg";
export { ForwardRef as ReactComponent };